import { SnackbarKey, useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_WORKSPACE } from './mutation'
import { Data, UseDeleteWorkspace, UseDeleteWorkspaceProps, Variables } from './types'

export const useDeleteWorkspace = ({ name }: UseDeleteWorkspaceProps): UseDeleteWorkspace => {
  const { t } = useTranslation('features/workspace')
  const { enqueueSnackbar } = useSnackbar()

  const enqueueErrorSnackbar = (): SnackbarKey =>
    enqueueSnackbar(t('delete.action.error', { workspaceName: name }), { variant: 'error' })

  const { isPending: loading, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_WORKSPACE,
    onCompleted: async (data: Data) => {
      const { deleteWorkspace } = data

      if (deleteWorkspace) {
        const { errors } = deleteWorkspace

        if (errors && errors.length > 0) {
          enqueueErrorSnackbar()
        }
      } else {
        enqueueSnackbar(t('delete.action.success', { workspaceName: name }), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['getWorkspacesForTable'],
  })

  const deleteWorkspace: UseDeleteWorkspace['deleteWorkspace'] = id =>
    mutateAsync({
      input: { id },
    })

  return { deleteWorkspace, loading }
}
